<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{'picture.new' | translate}}</span>
            <button mat-button class="mat-icon-button"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0">

      <cropper [file]="file" [page]="'picture'" [defaultRatio]="true" (sendImg)="setImg($event)"></cropper>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button mat-raised-button
                (click)="dialogRef.close(newImage)"
                class="save-button mat-accent"
                [disabled]="!newImage"
                aria-label="SAVE">
          {{'main.save' | translate}}
        </button>
    </div>
</div>
